export default __webpack_public_path__ + "static/icon_character_personality-1.0.0.png";